"use strict";

import angular from "angular";

function compareToDirective() {
    return {
        require: "ngModel",
        scope: {
            compareTo: "="
        },
        link(scope, element, attrs, ctrl) {
            scope.$watch(
                function () {
                    let combined;
                    if (scope.compareTo || ctrl.$viewValue) {
                        combined = scope.compareTo + "_" + ctrl.$viewValue;
                    }
                    return combined;
                },
                function (value) {
                    if (value) {
                        ctrl.$parsers.unshift(function (viewValue) {
                            const origin = scope.compareTo;
                            if (origin !== viewValue) {
                                ctrl.$setValidity("compareTo", false);
                                return undefined;
                            }
                            ctrl.$setValidity("compareTo", true);
                            return viewValue;
                        });
                    }
                }
            );
        }
    };
}

compareToDirective.$inject = [];

const name = "compareTo";
const factory = compareToDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
